import React, { useState } from 'react';
import styled from 'styled-components';
import { ChevronRight } from 'lucide-react';
import { ThemedText } from './ThemedText';
import { ThemedView } from './ThemedView';
import { useTheme } from '../context/ThemeContext';

const CollapsibleHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  padding: ${props => props.theme.spacing.sm};
  border-radius: ${props => props.theme.borderRadius.sm};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${props => props.theme.colors.backgroundSecondary};
  }

  &:active {
    opacity: 0.8;
  }
`;

const ChevronIcon = styled.span`
  display: inline-block;
  width: 18px;
  height: 18px;
  transition: transform 0.2s ease;
  transform: rotate(${props => props.isOpen ? '90deg' : '0deg'});
  color: ${props => props.theme.colors.icon};
  font-size: 14px;
`;

const CollapsibleContent = styled.div`
  margin-top: 6px;
  margin-left: 24px;
  overflow: hidden;
  transition: max-height 0.3s ease;
  max-height: ${props => props.isOpen ? '1000px' : '0'};
`;

export const Collapsible = ({ children, title }) => {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();

  return (
    <ThemedView>
      <CollapsibleHeader
        theme={theme}
        onClick={() => setIsOpen(!isOpen)}
      >
        <ChevronIcon theme={theme} isOpen={isOpen}>
          <ChevronRight size={14} />
        </ChevronIcon>
        <ThemedText type="defaultSemiBold">{title}</ThemedText>
      </CollapsibleHeader>
      {isOpen && (
        <CollapsibleContent isOpen={isOpen}>
          <ThemedView>
            {children}
          </ThemedView>
        </CollapsibleContent>
      )}
    </ThemedView>
  );
};